import { render, staticRenderFns } from "./modifyLogistics.vue?vue&type=template&id=c1d9b826&scoped=true&"
import script from "./modifyLogistics.vue?vue&type=script&lang=js&"
export * from "./modifyLogistics.vue?vue&type=script&lang=js&"
import style0 from "./modifyLogistics.vue?vue&type=style&index=0&id=c1d9b826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d9b826",
  null
  
)

export default component.exports